<template>
  <div class="posttype-filter">
    <div class="form-check form-check-all">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        ref="all"
        id="post_types_all"
        v-model="value"
      />
      <label class="form-check-label" for="post_types_all">{{
        $store.state.i18n.all
      }}</label>
    </div>

    <PosttypeToggle
      v-for="item in items"
      :key="item.term_id"
      :checkbox="item"
    />
  </div>
</template>

<script>
import PosttypeToggle from "./PosttypeToggle";

export default {
  name: "PosttypeFilter",
  components: {
    PosttypeToggle,
  },
  computed: {
    value: {
      get() {
        return this.$store.state.post_types.length == 0;
      },
      set(val) {
        this.$store.commit("REMOVE_ALL_POSTTYPES");
        this.$refs.all.checked = true;
        this.$store.dispatch("newRequest");
      },
    },
    items: function () {
      return this.$store.state.post_types_list;
    },
  },
};
</script>
